import Joi from "joi";
import errorsResolver from "../schemeUtils";

const createCashBoxScheme = (disableNamePattern, enableMobilePattern, isMainEnable) => {
    const FIELD_LENGTH = 100;
    const DEPARTMENT_FIELD_LENGTH =  disableNamePattern ? 20 : 14;
    const ADDRESS_FIELD_LENGTH = 10;
    const PHONE_LENGTH = 20;
    const ADDITIONAL_INFO_LENGTH = 400;
    const CITY_LENGTH = 40;

    let nameSchema = Joi.string()
        .max(DEPARTMENT_FIELD_LENGTH)
        .required()
        .messages({
            "string.base": `Название должно быть строкой`,
            "string.empty": `Название обязательное поле`,
            "string.max": `Название должно быть до ${DEPARTMENT_FIELD_LENGTH} символов`,
        });

    if (disableNamePattern) {
        nameSchema = nameSchema.pattern(new RegExp('^[а-яА-ЯёЁ ]{1,17}№\\d{1,3}$'))
            .messages({
                "string.pattern.base": `Название содержит некорректные символы`
            });
    } else {
        nameSchema = nameSchema.pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9.,\\- ]*$'))
            .messages({
                "string.pattern.base": `Название содержит некорректные символы`
            });
    }

    let сashBoxScheme =  Joi.object({
        index: Joi.any(),
        name: nameSchema,
        phone: Joi.string()
            .required()
            .max(PHONE_LENGTH)
            .pattern(new RegExp('^[0-9\\-+ ]{1,20}$'))
            .error(errorsResolver({
                max: `Номер телефона должен быть длинной до ${PHONE_LENGTH} символов`,
                required: `Номер телефона обязательное поле`,
                pattern: `Номер телефона содержит некорректные символы`
            })),
        city: Joi.string()
            .max(CITY_LENGTH)
            .required()
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ\\-.() ]{1,40}$'))
            .error(errorsResolver({
                max: `Город должен быть до ${CITY_LENGTH} символов`,
                required: `Город обязательное поле`,
                pattern: `Город содержит некорректные символы`
            })),
        street: Joi.string()
            .max(FIELD_LENGTH)
            .required()
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\-№:()/.,\" ]{1,100}$'))
            .error(errorsResolver({
                max: `Улица должна быть до ${FIELD_LENGTH} символов`,
                required: `Улица обязательное поле`,
                pattern: `Улица содержит некорректные символы`
            })),
        house: Joi.string()
            .max(ADDRESS_FIELD_LENGTH)
            .required()
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9]{1,10}$'))
            .error(errorsResolver({
                max: `Дом должен быть до ${ADDRESS_FIELD_LENGTH} символов`,
                required: `Дом обязательное поле`,
                pattern: `Дом содержит некорректные символы`
            })),
        building: Joi.string()
            .max(ADDRESS_FIELD_LENGTH)
            .allow('')
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9]{1,10}$'))
            .error(errorsResolver({
                max: `Корпус должен быть до ${ADDRESS_FIELD_LENGTH} символов`,
                required: `Корпус обязательное поле`,
                pattern: `Корпус содержит некорректные символы`
            })),
        office: Joi.string()
            .max(ADDRESS_FIELD_LENGTH)
            .allow('')
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9]{1,10}$'))
            .error(errorsResolver({
                max: `Офис должен быть до ${ADDRESS_FIELD_LENGTH} символов`,
                required: `Офис обязательное поле`,
                pattern: `Офис содержит некорректные символы`
            })),
        leaderId: Joi.object({
            label: Joi.string()
                .max(FIELD_LENGTH)
                .required('')
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\- ]{1,100}$'))
                .error(errorsResolver({
                    max: `Руководитель должен быть до ${FIELD_LENGTH} символов`,
                    required: `Руководитель обязательное поле`,
                    pattern: `Руководитель содержит некорректные символы`
                })),
            value: Joi.number()
                .error(errorsResolver({
                    number: `Должно быть число`
                }))
        }).invalid(null)
            .required()
            .error(errorsResolver({
                invalid: `Руководитель обязательное поле`,
                required: `Руководитель обязательное поле`,
            })),
        chiefAccountantId: Joi.object({
            label: Joi.string()
                .max(FIELD_LENGTH)
                .required('')
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\- ]{1,100}$'))
                .error(errorsResolver({
                    max: `Главный бухгалтер должен быть до ${FIELD_LENGTH} символов`,
                    required: `Главный бухгалтер обязательное поле`,
                    pattern: `Главный бухгалтер содержит некорректные символы`
                })),
            value: Joi.number()
                .error(errorsResolver({
                    number: `Должно быть число`
                }))
        }).invalid(null)
            .required()
            .error(errorsResolver({
                invalid: `Главный бухгалтер обязательное поле`,
                required: `Главный бухгалтер обязательное поле`,
            })),
        accountantId: Joi.object({
            label: Joi.string()
                .max(FIELD_LENGTH)
                .required('')
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\- ]{1,100}$'))
                .error(errorsResolver({
                    max: `Бухгалтер должен быть до ${FIELD_LENGTH} символов`,
                    required: `Бухгалтер обязательное поле`,
                    pattern: `Бухгалтер содержит некорректные символы`
                })),
            value: Joi.number()
                .error(errorsResolver({
                    number: `Должно быть число`
                }))
        }).invalid(null)
            .required()
            .error(errorsResolver({
                invalid: `Бухгалтер обязательное поле`,
                required: `Бухгалтер обязательное поле`,
            })),
        seniorCommodityExpertId: Joi.object({
            label: Joi.string()
                .max(FIELD_LENGTH)
                .required('')
                .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\- ]{1,100}$'))
                .error(errorsResolver({
                    max: `Старший товаровед должен быть до ${FIELD_LENGTH} символов`,
                    required: `Старший товаровед обязательное поле`,
                    pattern: `Старший товаровед содержит некорректные символы`
                })),
            value: Joi.number()
                .error(errorsResolver({
                    number: `Должно быть число`
                }))
        })
            .invalid(null)
            .required()
            .error(errorsResolver({
                invalid: `Старший товаровед обязательное поле`,
                required: `Старший товаровед обязательное поле`,
            })),
        additionalInfo: Joi.string()
            .max(ADDITIONAL_INFO_LENGTH)
            .allow('')
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9,\\- ]{1,400}$'))
            .error(errorsResolver({
                max: `Дополнительная информация должна быть до ${ADDITIONAL_INFO_LENGTH} символов`,
                required: `Дополнительная информация обязательное поле`,
                pattern: `Дополнительная информация содержит некорректные символы`
            })),
        goodsSpecialistsIds: Joi.array().items(
            Joi.object({
                value: Joi.number()
                    .error(errorsResolver({
                        number: `Должно быть число`
                    })),
                label: Joi.string()
                    .max(FIELD_LENGTH)
                    .required('')
                    .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\- ]{1,100}$'))
                    .error(errorsResolver({
                        max: `ФИО товароведа должно быть до ${FIELD_LENGTH} символов`,
                        required: `Товароведы обязательное поле`,
                        pattern: `Поле товароведы содержит некорректные символы`
                    }))
            })
        )
            .invalid(null)
            .required()
            .min(1)
            .max(50)
            .error(errorsResolver({
                invalid: `Товароведы обязательное поле`,
                required: `Товароведы обязательное поле`,
                min: `Товароведы обязательное поле`,
                arrayMax: 'Не более 50 товароведов'
            })),
        number: Joi.string()
            .max(DEPARTMENT_FIELD_LENGTH)
            .required()
            .pattern(new RegExp('^[a-zA-Zа-яА-ЯёЁ0-9\\- ]*$'))
            .error(errorsResolver({
                max: `Номер должен быть до ${DEPARTMENT_FIELD_LENGTH} символов`,
                required: `Номер обязательное поле`,
                pattern: `Номер содержит некорректные символы`
        })),
        autoCashBox: Joi.boolean().optional()
    });
    if (isMainEnable) {
        сashBoxScheme = сashBoxScheme.keys({
            isMain: Joi.boolean().optional()
        });
    }
    if (enableMobilePattern) {
        сashBoxScheme = сashBoxScheme.keys({
            mobilePhone: Joi.string()
                .allow('')
                .pattern(new RegExp('^(\\+375 \\d{2} \\d{3} \\d{2} \\d{2})|(\\+375 __ ___ __ __)$'))
                .error(errorsResolver({
                    pattern: `Некорректно введен номер`
                })),
        });
    }
 return сashBoxScheme
}


export default createCashBoxScheme;
